'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var ModuleAct3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data.module1.act3 };
}, (0, _extends3.default)({}, moduleActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ModuleAct3, _Component);

  function ModuleAct3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ModuleAct3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ModuleAct3.__proto__ || (0, _getPrototypeOf2.default)(ModuleAct3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Reminder',
      moduleId: 1,
      appId: 3,
      isCompleted: _this.props.app.isCompleted || false
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(ModuleAct3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title,
              ' - My activities to try for this fortnight'
            )
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Record changes to make: Sometimes writing things down encourages us to get prepared and keep track of what we are trying to change. Use this planner or your own to do it.'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Vegetable providing diary: Your activity this week is to record all occasions you provide and offer vegetables to your child and whether he/she ate or tried to eat the vegetable. You will find a vegetable providing diary under "Resources".'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Check out module 1 extra information: If you didn\'t get a chance to cover all the information in module 1, you can always go back to the extra information on the sidebar.'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Try a new recipe: There are recipes provided in the navigation bar at the top of the webpage. These provide you with ideas for incorporating vegetables into other foods.'
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Fruit providing diary: If you have time this week, you can also use the vegie providing diary to plan and record opportunities to provide fruit daily. This strategy works for both fruit and vegetables.'
              )
            ),
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
        )
      );
    }
  }]);
  return ModuleAct3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModuleAct: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = ModuleAct3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Activities/Act3.js
// module id = 1162
// module chunks = 0